module.exports = __webpack_public_path__ + "static/media/tanzania.4a2b9685.svg";